import tinymce from 'tinymce'

/**
 * 创建label标签
 */
class Label {
  constructor (editor) {
    const defaultAttrs = {
      style: {
        position: 'absolute',
        top: '2px',
        left: '0',
        color: '#BFC7E0',
        padding: '.25%',
        margin: '5px',
        width: '80%',
        overflow: 'hidden',
        'font-size': '14px',
        'white-space': 'pre-wrap'
      }
    }
    const text = editor.getElement().getAttribute('placeholder') || editor.settings.placeholder
    const attr = editor.settings.placeholder_attrs || defaultAttrs
    const contentAreaContainer = editor.getContentAreaContainer()
    tinymce.DOM.setStyle(contentAreaContainer, 'position', 'relative')
    this.el = tinymce.DOM.add(contentAreaContainer, 'label', attr, text)
  }
  hide () {
    tinymce.DOM.setStyle(this.el, 'display', 'none')
  }
  show () {
    tinymce.DOM.setStyle(this.el, 'display', '')
  }
}
/**
 * 注册插件
*/
tinymce.PluginManager.add('placeholder', (editor) => {
  editor.on('init', function () {
    const label = new Label(editor)
    const onFocus = function () {
      if (!editor.settings.readonly === true) {
        label.hide()
      }
      editor.execCommand('mceFocus', false)
    }
    const onBlur = function () {
      if (editor.getContent() === '') {
        label.show()
      } else {
        label.hide()
      }
    }
    onBlur()
    tinymce.DOM.bind(label.el, 'click', onFocus)
    editor.on('focus', onFocus)
    editor.on('blur', onBlur)
    editor.on('change', onBlur)
    editor.on('setContent', () => {
      label.hide()
    })
  })
})